/**
 * Race a promise (or any value) against a timeout. Rejects with an
 * Error("Operation timed out") if the promise doesn't settle in time.
 * Non-promise values are wrapped with Promise.resolve() so synchronous
 * save functions that return an object/boolean don't throw "then is not
 * a function".
 * @param {Promise|*} promise
 * @param {number} ms - Timeout in milliseconds
 * @returns {Promise}
 */
export function withTimeout(promise, ms) {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error("Operation timed out")), ms)
        Promise.resolve(promise).then(
            (value) => {
                clearTimeout(timer)
                resolve(value)
            },
            (err) => {
                clearTimeout(timer)
                reject(err)
            }
        )
    })
}
